/* eslint-disable @typescript-eslint/no-use-before-define */
import { Action, createFeatureSelector, StoreModule } from '@ngrx/store';
import { EulaAction, SetEula } from 'src/app/components/eula/eula.actions';
import { Eula } from '../../types/content-types';

export const selectEula = createFeatureSelector<Eula>('eula');
export const eulaStoreModule = StoreModule.forFeature('eula', eulaReducer);

export const eulaInitialState = new Eula();

export function eulaReducer(state: Eula = eulaInitialState, action: Action) {
    switch (action.type) {
        case EulaAction.setEula:
            return (action as SetEula).eula;
        default:
            return state;
    }
}
